<template>
  <div class="group-sku-box">
    <template>
      <div class="new-input-box">
        <div class="new-form-label-box">分组名称</div>
        <el-input
          v-model="fenZuGroupName"
          placeholder="请输入"
          style="width: 320px"
        ></el-input>
        <div style="display: inline-block; margin-left: 8px">
          <el-button type="primary"  @click="handleSearch">查询</el-button>
          <el-button style="margin-left: 8px" @click="handleReset">重置</el-button>
        </div>
      </div>
      <div style="margin-top: 12px">
        <el-button type="default" @click="addGroup">新增分组</el-button>
      </div>
      <div class="new-table-box" style="margin-top: 16px">
        <el-table
          :data="fenZuTable"
          v-loading="fenZuTableLoading"
          height="420"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column label="分组名称" prop="groupName"></el-table-column>
          <el-table-column label="所选sku数" prop="skuNum"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="eddGroup(scope.row)" style="width: auto; margin: 0;"
                >编辑名称</el-button
              >
              <el-button
                type="text"
                style="width: auto;  margin: 0;"
                @click="handleDeteleData(scope.row)"
                >删除</el-button
              >
              <el-button
                type="text"
                style="width: auto;  margin: 0;"
                @click="handleAddSkuBtn(scope.row)"
                >添加sku</el-button
              >
              <el-button type="text" @click="showDeteleGroupBtn(scope.row)" style="width: auto;  margin: 0;"
                >删除sku</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页器 -->
      <div class="new-pagination-page" style="margin-top: 20px">
        <el-pagination
          background
          style="text-align: right"
          @size-change="handleGroupSize"
          @current-change="handleGroupCurrent"
          :current-page="fenZuCurrent"
          :page-sizes="[10, 20, 30, 50, 100, 500]"
          :page-size="fenZuSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fenZuTotal"
        ></el-pagination>
      </div>
    </template>
    <!-- 弹窗部分 -->
    <template>
      <!-- 新增分组、编辑名称 -->
      <el-dialog
        :visible="showGroupNameBox"
        :title="isGroupAdd ? '新增分组' : '编辑分组'"
        :before-close="handleCloseNameBox"
        width="446px"
        class="addNameDialog"
      >
        <div class="new-input-box" style="width: 100%;display: flex;align-items: center;">
          <div class="new-form-label-box">
            <span class="necessary-icon">*</span>
            分组名称
          </div>
          <el-input
            v-model="nowGroupData.groupName"
            placeholder="请输入"
            style="flex: 1"
            maxlength="15"
            show-word-limit
          ></el-input>
        </div>
        <div style="text-align: right; margin-top: 20px">
          <el-button @click="handleCloseNameBox">取消</el-button>
          <el-button
            type="primary"
            :disabled="sureLoading"
            @click="handleSureNameBox"
            >确认</el-button
          >
        </div>
      </el-dialog>
      <!-- 添加sku -->
      <el-dialog
        :visible="showAddGroup"
        title="添加sku"
        :before-close="closeAddGroup"
        width="446px"
        class="addSkuDialog"
      >
        <div class="new-input-box" style="width: 100%">
          <div style="width: 100%;display: flex;align-items: center;">
            <div class="new-form-label-box">
              <span class="necessary-icon">*</span>
              分组名称
            </div>
            <div class="new-form-label-box">{{ addGroupData.groupName }}</div>
          </div>
          <div style="width: 100%;display: flex;align-items: flex-start;margin-top: 12px;">
            <div class="new-form-label-box">
              <span class="necessary-icon">*</span>
              新增sku
            </div>
            <el-input
              v-model="addGroupData.skuStr"
              type="textarea"
              style="flex: 1"
              @input="handleInput"
              :autosize="{ minRows: 8, maxRows: 8 }"
              placeholder="多个sku用英文逗号隔开或者一行一个"
            ></el-input>
          </div>
          <div style="margin-top: 8px; margin-left: 70px;">
            <el-button  @click="sureInputSku" :disabled="inputSkuFlag">确认导入</el-button>
            <span style="margin-left: 8px;">成功导入{{successSku}}个，失败{{errorSku}}个</span>
          </div>
        </div>
        <div style="text-align: right; margin-top: 20px">
          <el-button
            type="primary"
            style="margin-left: 8px"
            @click="closeAddGroup(); groupSkuSearch()"
            >确认</el-button
          >
        </div>
      </el-dialog>
      <!-- 删除sku -->
      <el-dialog
        :visible="showDeteleGroup"
        title="删除sku"
        :before-close="closeDeteleGroup"
        width="460px"
        class="deteleSkuDialog"
      >
        <div class="new-input-box">
          <div>
            <div class="new-form-label-box">
              <span class="necessary-icon">*</span>
              分组名称
            </div>
            <div class="new-form-label-box">{{ deteleGroupData.groupName }}</div>
          </div>
          <div style="width: 100%;display: flex;align-items: flex-start;margin-top: 16px;">
            <div class="new-form-label-box">
              <span class="necessary-icon">*</span>
              sku列表
            </div>
            <div class="right-sku-list-box"  v-loading="skuLoading" style="flex: 1">
              <!-- <div class="right-sku-item" v-for="item in 100" :key="item"></div> -->
              <template v-if="skuList.length <= 0">
                <div style="width: 100%; height: 100%;text-align: center;display: flex; align-items: center;">
                  <div style="width: 100%; text-align: center;">
                    <img src="@/assets/images/default/暂无任何数据.png" />
                    <div style="margin-top: -50px;">暂无任何数据</div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="right-sku-item" v-for="(rItem, rIndex) in skuList" :key="'rightItem'+ rIndex">
                    <img :src="rItem.logo" class="skuImge" alt="商品图片" />
                    <div class="desc">
                      <p :title="rItem.skuName" class="goodsName">
                        {{ rItem.skuName }}
                      </p>
                      <div class="foot">
                        <span class="money">￥{{ rItem.jdPrice }}</span>
                        <span class="goodsId">sku ID:{{ rItem.skuId }}</span>
                      </div>
                    </div>
                    <div class="clearIcon el-icon-remove-outline" @click="clearGoods(rItem, rIndex)"></div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div style="text-align: right; margin-top: 20px">
          <el-button
            @click="closeDeteleGroup"
            >取消</el-button
          >
          <el-button
            type="primary"
            style="margin-left: 8px"
            :disabled="removeLoading"
            @click="sureDeteleGroup"
            >确认</el-button
          >
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import {
  saveGroup,
  delSkuGroup,
  removeSkuList,
  getSkuListByGroup,
  addSkuByType,
  getGroupPage
} from '@/api/group/index.js'

export default {
  name: "groupSkuBox",
  data() {
    return {
      fenZuGroupName: "",
      fenZuTable: [],
      fenZuTableLoading: false,
      fenZuTotal: 0,
      fenZuSize: 10,
      fenZuCurrent: 1,
      showGroupNameBox: false,
      isGroupAdd: true,
      nowGroupData: {},
      dialogGroupName: "",
      showAddGroup: false,
      addGroupData: {},
      successSku: 0,
      errorSku: 0,
      showDeteleGroup: false,
      deteleGroupData: {},
      skuList: [],
      deteleLiat: [],
      inputSkuFlag: false,
      skuLoading: false,
      sureLoading: false,
      removeLoading: false,
    };
  },
  mounted() {
    this.groupSkuSearch();
  },
  methods: {
    handleSearch(){
      this.fenZuSize = 10;
      this.fenZuCurrent = 1;
      this.groupSkuSearch();
    },
    handleReset() {
      this.fenZuSize = 10;
      this.fenZuCurrent = 1;
      this.fenZuGroupName = '';
      this.groupSkuSearch();
    },
    groupSkuSearch() {
      this.fenZuTableLoading = true;
      this.fenZuTable = [];
      let params = {
        groupName: this.fenZuGroupName,
        current:this.fenZuCurrent,
        size: this.fenZuSize
      };
      getGroupPage(params).then(res => {
        console.log("getGroupPage", res)
        this.fenZuTableLoading = false;
        if(res.code == 1){
          this.fenZuTable = res.data.records || [];
          this.fenZuTotal = res.data.total || 0;
        }else {
          this.$message.error(res);
        }
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => {
        this.fenZuTableLoading = false;
      })
    },
    handleGroupSize(val) {
      this.fenZuSize = val;
      this.groupSkuSearch();
    },
    handleGroupCurrent(val) {
      this.fenZuCurrent = val;
      this.groupSkuSearch();
    },
    addGroup() {
      this.isGroupAdd = true;
      this.showGroupNameBox = true;
    },
    eddGroup(row) {
      this.isGroupAdd = false;
      this.nowGroupData = JSON.parse(JSON.stringify(row));
      this.showGroupNameBox = true;
    },
    handleCloseNameBox() {
      this.showGroupNameBox = false;
      this.isGroupAdd = true;
      this.nowGroupData = {};
      this.dialogGroupName = "";
    },
    handleSureNameBox() {
      if(this.sureLoading) return;
      if(!this.nowGroupData.groupName || this.nowGroupData.groupName == ''){
        this.$message.warning("分组名称不能为空");
        return;
      }
      let params = {
        groupName: this.nowGroupData.groupName,
      };
      if(!this.isGroupAdd) {
        params.groupId = this.nowGroupData.groupId;
      }
      console.log("params", params);
      this.sureLoading = true;
      saveGroup(params).then(res => {     
        if(res.code == 1){
          this.$message.success(res.message);
          this.handleCloseNameBox();
          this.groupSkuSearch();
        }else {
          this.$message.error(res);
        }
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => {
        this.sureLoading = false;
      })
    },
    handleDeteleData(row) {
      this.$confirm("是否确认删除此分组？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          console.log("确认删除");
          let params = row;
          if(!params.groupId){
            this.$message.error("该数据缺少id,无法操作");
            return;
          }
          delSkuGroup(params.groupId).then(res => {
            console.log("delSkuGroup", res);        
            if(res.code == 1){
              this.$message.success(res.message);
              this.groupSkuSearch();
            }else {
              this.$message.error(res);
            }
          }).catch(err => {
            this.$message.error(err.message);
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleAddSkuBtn(row) {
      this.addGroupData = {};
      let testObj = JSON.parse(JSON.stringify(row));
      this.addGroupData.groupName = testObj.groupName;
      this.addGroupData.groupId = testObj.groupId;
      this.successSku = 0;
      this.errorSku = 0;
      this.showAddGroup = true;
    },
    closeAddGroup() {
      this.showAddGroup = false;
      this.addGroupData = {};
      this.successSku = 0;
      this.errorSku = 0;
    },
    // 确认导入
    sureInputSku() {
      if(this.inputSkuFlag) return;
      if(this.addGroupData.skuStr == '' || !this.addGroupData.skuStr) {
        this.$message.warning("导入的SKU列表不能为空");
        return;
      };
      let lines = this.addGroupData.skuStr.split('\n');  
      let finalArray = lines.flatMap(line => line.split(','));  
      finalArray = finalArray.map(item => item.trim());
      let skuId = finalArray.join(',')
      console.log("skuId: " , skuId);
      let params = {
        groupId: this.addGroupData.groupId,
        skuId: skuId,
      }
      this.inputSkuFlag = true;
      console.log("addSkuByType-params", params);
      addSkuByType(params).then(res => {
        if(!!res.code && res.code == 1){
          this.$message.success(res.message);
          this.successSku = res.data.successNum || 0;
          this.errorSku = res.data.failNum || 0;
        }else {
          this.$message.error(res);
        }
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => {
        this.inputSkuFlag = false;
      })
    },
    handleInput(value) {
      // 只允许输入数字、逗号、换行和空格
      const filteredValue = value.replace(/[^0-9,\n\s]/g, '');
      this.addGroupData.skuStr = filteredValue;
    },
    showDeteleGroupBtn(row) {
      if(this.skuLoading) return;
      if(!row.groupId){
        this.$message.error("该数据缺少id,无法操作");
        return;
      }
      this.showDeteleGroup = true;
      this.deteleGroupData = JSON.parse(JSON.stringify(row));
      this.skuLoading = true;
      getSkuListByGroup(row.groupId).then(res => {
        if(res.code == 1) {
          this.skuList = res.data;
        }else {
          this.$message.error(res);
          this.skuList = [];
        }
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => {
        this.skuLoading = false;
      });
    },
    closeDeteleGroup() {
      this.showDeteleGroup = false;
      this.deteleGroupData = {};
      this.skuList = [];
      this.deteleLiat = [];
    },
    sureDeteleGroup() {
      if(this.removeLoading) return;
      console.log("确认", this.deteleLiat);
      let paramsArr = [];
      let paramsObj = {};
      this.deteleLiat.forEach(item => {
        if(!!item.skuId) paramsArr.push(item.skuId);
      });
      paramsObj = {
        groupId: this.deteleGroupData.groupId,
        skuList: paramsArr
      }
      console.log("removeSkuList-paramsObj", paramsObj);
      this.removeLoading = true;
      removeSkuList(paramsObj).then(res => {
        if(res.code == 1){
          this.$message.success("保存成功");
          this.closeDeteleGroup();
          this.groupSkuSearch();
        }else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => {
        this.removeLoading = false;
      })
    },
    // 删除商品列表
    clearGoods(item, index) {
      this.deteleLiat.push(this.skuList[index]);
      this.skuList.splice(index, 1);
    }
  },
};
</script>

<style lang="scss" scoped>
.new-form-label-box {
  display: inline-block;
  margin-right: 8px;
  .necessary-icon {
    color: #FF4552;
  }
}
.group-sku-box {
  width: 100%;
  height: 100%;
}
.addNameDialog {
  ::v-deep .el-dialog {
    margin-top: 32vh !important;
  }
}
.addSkuDialog {
  ::v-deep .el-dialog {
    margin-top: 26vh !important;
  }
}
.deteleSkuDialog {
  ::v-deep .el-dialog {
    margin-top: 26vh !important;
  }
  .right-sku-list-box {
    width: 325px;
    height: 300px;
    display: inline-block;
    overflow: hidden;
    overflow-y: auto;
    border: 1px solid #F2F2F2;
    .right-sku-item {
      width: 100%;
      height: 60px;
      // border: 1px solid #F2F2F2;
      // background-color: aliceblue;
      display: flex;
      align-items: center;
      padding-left: 8px;
      .skuImge {
        width: 48px;
        height: 48px;
        background-color: #f9f9f9;
      }
      .desc {
        flex: 1;
        margin-left: 5px;
        .goodsName {
          color: #333;
          font-size: 14px;
          margin: 0;
          display: -webkit-box;
          word-break: break-all;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          line-height: 18px;
        }
        .foot {
          display: flex;
          font-size: 14px;
          .goodsId {
            color: #999;
          }
          .money {
            color: #ff872f;
            margin-right: 8px;
          }
        }
      }
      .clearIcon {
        margin: 0 8px;
        cursor: pointer;
      }
    }
    .right-sku-item  + .right-sku-item  {
      margin-top: 8px;
      
    }
  }
}
</style>